export default "__VITE_ASSET__BUkwQZEF__"